module.exports = "/_next/static/images/visa-bulletin-trend-c22f6baae5041a21c4f675a97a1c615a.png";